export enum PopupType {
    error = 'error',
    warning = 'warning',
    info = 'info',
    success = 'success'
}